export default __webpack_public_path__ + "static/media/parkingslot_logo.dab9ca33.png";